module.exports = __webpack_public_path__ + "static/media/Kanit-SemiBold.6e8be535.ttf";